<template>
    <Head>
        <title>{{ post.title }}</title>
    </Head>

    <frontend-layout>

        <template #page_header>
            <div
                class="flex justify-center gap-4 bg-primary-100 p-4 text-center text-gray-800"
            >
                <span
                >We also operate
                    <a href="https://emt-ce.com" class="link">EMT-CE.com</a>
                    where you can get CE hours 100% online.</span
                >
            </div>
        </template>

        <div class="container mx-auto max-w-[1034px] px-4 pb-12 pt-12">
            <div class="flex flex-col gap-4">
                <Link
                    :href="route('frontend.resources.index')"
                    class="mb-4 text-[16px] text-gray-600 hover:cursor-pointer hover:text-gray-800 md:mb-8"
                >Back to all articles
                </Link>
                <div class="flex justify-between">
                    <resource-post-tag :post-type="post.type"/>
                    <div class="text-[16px] text-gray-600 md:hidden">
                        Updated
                        {{
                            dayjs(post.updated_at)
                                .utc(true)
                                .tz($page.props.display_timezone)
                                .format($page.props.date_formats.short_nice)
                        }}
                    </div>
                </div>
            </div>

            <div class="flex flex-col lg:flex-row lg:gap-20">
                <div class="">
                    <div class="pb-4">
                        <frontend-header-h1
                            :text="post.title"
                        ></frontend-header-h1>
                        <div
                            class="mt-2 flex items-center justify-start gap-4 text-[16px] text-gray-600"
                        >
                            <div class="hidden md:block">
                                Updated
                                {{
                                    dayjs(post.updated_at)
                                        .utc(true)
                                        .tz($page.props.display_timezone)
                                        .format(
                                            $page.props.date_formats.short_nice
                                        )
                                }}
                            </div>
                            <div class="flex flex-wrap gap-2">
                                <span
                                    class="whitespace-nowrap rounded border px-2 py-1"
                                    v-for="category in post.categories"
                                >
                                    {{ category.title }}
                                </span>
                            </div>
                        </div>
                        <hr class="mt-4"/>
                    </div>
                    <div v-if="post.thumbnail" class="flex flex-col gap-4 pb-4">
                        <img :src="post.thumbnail"/>
                    </div>
                    <div
                        class="cms-wysiwyg-content flex-grow"
                        v-html="post.html_content"
                    ></div>
                    <div>
                        <div class="">
                            <ul class="text-gray-700 flex flex-col gap-8">
                                <li
                                    class="break-all"
                                    v-for="(
                                reference, refIndex
                            ) in post.references"
                                >
                                    {{ refIndex + 1 }}. <span v-html="reference.reference"></span> <a
                                    :href="reference.reference_url" class="link underline">{{
                                        reference.reference_url
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div
                    class="mx-auto mt-8 flex w-full flex-none flex-col gap-8 md:w-auto md:flex-row lg:mt-0 lg:flex-col"
                >
                    <div class="">
                        <emtprep-upsell-ad/>
                    </div>
                    <div class="">
                        <emtce-promo-ad/>
                    </div>
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import EmtprepUpsellAd from "@/Components/EmtprepUpsellAd";
import EmtcePromoAd from "@/Components/EmtcePromoAd";
import ResourcePostTag from "@/Components/ResourcePostTag";

export default {
    name: "ResourceBlogShow",
    components: {
        FrontendLayout,
        EmtprepUpsellAd,
        EmtcePromoAd,
        ResourcePostTag,
    },
    props: {
        post: {
            type: Object,
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped></style>
